import 'whatwg-fetch';
import './polyfill';

import tippy from 'tippy.js';
import {roundArrow} from 'tippy.js';

import initContactForm from './components/contact-form';
import './components/camp-360';
import './components/hero-slider';
//import './components/inview-effects.js'
import './components/Inview';
import './components/modal';
import './components/Slider.js';
import './components/Tabset.js';

initContactForm();

tippy('[data-tippy-content]', {
    animation: "scale-subtle",
    theme: "yellow",
    arrow: roundArrow
});

